import Axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { segmentKeys } from "src/query-keys";
import { APIError, Segment } from "src/types";
import { ExpressionItem } from "src/utils/segments-bulk-expression.utils";

export interface SegmentBulkMutationData {
  segmentIdList: Array<Segment["segmentId"]>;
  propertyExpressionList: ExpressionItem[];
  useDefaultValues: boolean;
}

export interface SegmentBulkUpdateResponse {
  validationReportSummary: {
    allValid: boolean;
    defaultValueExists: boolean;
    errorMessageList: APIError[];
  };
  validationReportList: [
    {
      nbValid: number;
      nbFailedEvaluation: number;
      nbFailedRequired: number;
      nbFailedInvalid: number;
      defaultValueExists: boolean;
      errorMessageEvaluation: APIError;
      errorMessageRequired: APIError;
      errorMessageInvalid: APIError;
    }
  ];
}

export async function mutationFn(scenarioId: number | string, data: SegmentBulkMutationData) {
  const url = `/planning-api/scenarios/${scenarioId}/segments`;
  const response = await Axios.put<SegmentBulkMutationData, AxiosResponse<SegmentBulkUpdateResponse>>(url, data);
  return response.data;
}

export function useSegmentBulkUpdateMutation(scenarioId: number | string) {
  const queryClient = useQueryClient();

  return useMutation<SegmentBulkUpdateResponse, AxiosError<APIError[]>, SegmentBulkMutationData, unknown>(
    (data: SegmentBulkMutationData) => mutationFn(scenarioId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(segmentKeys.all(scenarioId));
      },
    }
  );
}
